// All the possible results of MPN ID validation on the Complete Account Setup page.
export enum MpnValidationResult {
    None = 0,
    NotFound = 1,
    Success = 2,
    InUse = 3,
    TooManyAttempts = 4,
    ServerError = 5
  }
  